<template>
  <span>{{ item[header.value] ? formatDate(item[header.value] * 1000, 'DD-MM-YYYY') : '' }}</span>
</template>

<script>
import { utils } from '@/mixins/index';

export default {
  name: 'DateContent',
  mixins: [utils],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    header: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
